import React from 'react';
import { SearchError } from '../../common/search-error';
export var SearchErrorScreen = function SearchErrorScreen(_ref) {
  var _ref$onRetry = _ref.onRetry,
    onRetry = _ref$onRetry === void 0 ? function () {
      return null;
    } : _ref$onRetry;
  return /*#__PURE__*/React.createElement(SearchError, {
    onRetry: onRetry
  });
};